import http from './ApiConfig';
import { Service } from './Service';
import { AtualizarImagemResponseType } from '../types/arquivos/AtualizarImagemResponseType';
import { ExcluirArquivoType } from '@/types/arquivos/ExcluirArquivoType';
import { ObterArquivoType } from '@/types/arquivos/ObterArquivoType';
import { getToken } from '@/utils/Token';

interface DownloadResponse {
  ok: boolean;
  status?: number;
  statusText?: string;
  blob: () => Promise<Blob>;
  headers: {
    get: (name: string) => string | null;
  };
}

export class ArquivoS3Service extends Service {
  constructor() {
    super('ArquivoS3');
  }

  public ObterUrlImagem(caminhoArquivo: string): Promise<ObterArquivoType> {
    const url = `${this._nomeControle}/obter-url-imagem-usuario`;
    const data = { caminhoArquivo };
    const configuracoes = this.GetHeader();
    return http.post(url, data, configuracoes);
  }

  public AtualizarImagemUsuario(usuarioId: string, chaveArquivoAtual: string | null, arquivoImagem: File): Promise<AtualizarImagemResponseType> {
    const url = `${this._nomeControle}/atualizar-imagem-usuario/${usuarioId}`;
    const formData = new FormData();
    formData.append('chaveArquivoAtual', chaveArquivoAtual == null ? '' : chaveArquivoAtual);
    formData.append('imagem', arquivoImagem);
    const configuracoes = this.GetHeader();

    if (configuracoes.headers && configuracoes.headers['Content-Type']) {
      delete configuracoes.headers['Content-Type'];
    }

    return http.post(url, formData, configuracoes);
  }

  public ExcluirImagemUsuario(usuarioId: string, chaveImagemAtual: string): Promise<ExcluirArquivoType> {
    const url = `${this._nomeControle}/excluir-imagem-usuario/${usuarioId}`;
    const data = { Chave: chaveImagemAtual };
    const configuracoes = this.GetHeader();
    return http.post(url, data, configuracoes);
  }

  public ExcluirArquivoPorIdentificadorS3(identificadorS3: string): Promise<ExcluirArquivoType> {
    const identificadorS3Encoded = identificadorS3.replace(/\//g, '___').replace(/\./g, '__');
    const url = `${this._nomeControle}/excluir-arquivo-por-identificador-s3/${identificadorS3Encoded}`;
    const configuracoes = this.GetHeader();
    return http.delete(url, configuracoes);
  }

  public AtualizarImagemPaciente(pacienteId: string | number, chaveArquivoAtual: string | null, arquivoImagem: File): Promise<AtualizarImagemResponseType> {
    const url = `${this._nomeControle}/atualizar-imagem-paciente/${pacienteId}`;
    const formData = new FormData();
    formData.append('chaveArquivoAtual', chaveArquivoAtual == null ? '' : chaveArquivoAtual);
    formData.append('imagem', arquivoImagem);
    const configuracoes = this.GetHeader();

    if (configuracoes.headers && configuracoes.headers['Content-Type']) {
      delete configuracoes.headers['Content-Type'];
    }

    return http.post(url, formData, configuracoes);
  }

  public AtualizarImagemClinica(clinicaId: string | number | bigint, chaveArquivoAtual: string | null, arquivoImagem: File): Promise<AtualizarImagemResponseType> {
    const url = `${this._nomeControle}/atualizar-imagem-clinica/${clinicaId}`;
    const formData = new FormData();
    formData.append('chaveArquivoAtual', chaveArquivoAtual == null ? '' : chaveArquivoAtual);
    formData.append('imagem', arquivoImagem);
    const configuracoes = this.GetHeader();

    if (configuracoes.headers && configuracoes.headers['Content-Type']) {
      delete configuracoes.headers['Content-Type'];
    }

    return http.post(url, formData, configuracoes);
  }

  /**
   * Faz o download de um arquivo do S3 via backend.
   * @param chave Chave do arquivo no S3
   * @returns Promise<DownloadResponse>
   */
  public static async downloadArquivo(chave: string): Promise<DownloadResponse> {
    const url = `/ArquivoS3/download?chave=${encodeURIComponent(chave)}`;
    const configuracoes = {
      responseType: 'blob' as const,
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    try {
      const response = await http.get(url, configuracoes);
      return {
        ok: true,
        blob: () => Promise.resolve(response.data),
        headers: {
          get: (name: string) => response.headers[name.toLowerCase()] || null,
        },
      };
    } catch (error: any) {
      return {
        ok: false,
        status: error.response?.status || 500,
        statusText: error.response?.statusText || 'Internal Server Error',
        blob: () => Promise.reject(error),
        headers: {
          get: () => null,
        },
      };
    }
  }
}
